import { getBrowserWidth } from "owa-config";
import { COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT } from "../utils/copilotChatDrawerConstants";

/**
 * Chat Drawer should only interact with folder pane in certain scenarios.
 * Currently, that is whether the browser width is below a certain breakpoint.
 */
export function shouldChatCollapseFolderPane(): boolean {
    return getBrowserWidth() < COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT;
}
